import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SessionService } from '@app/core';
import { TermsTypeKey } from '@common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class TermsService {
  private _sessionService = inject(SessionService);
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);


  public redirect = '';

  public continueTermsFlow(): void {
    this._router.navigate(['../terms'], { relativeTo: this._route });
  }

  public skipTerm(key: TermsTypeKey): void {
    this._sessionService.addSkippedTermType(key);
    this.continueTermsFlow();
  }

}
